<template>
  <div>
    <div
      class="glass-modal-backdrop position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center overflow-y-auto"
      style="z-index: 1055"
      @mouseup.self="handleMouseUp"
      @mousedown.self="handleMouseDown"
    >
      <div class="modal-content-wrapper mx-2 w-100 d-flex justify-content-center">
        <slot name="default"> </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalFormBlock',

  props: {
    position: {
      type: String,
      default: 'center'
    },

    title: {
      type: String,
      default: ''
    },
    closeOption: {
      type: Boolean,
      default: false
    }
  },

  emits: ['close'],

  data() {
    return {
      alreadyHidden: false,
      insideModal: false
    }
  },

  mounted() {
    // Gestion du scroll
    if (document.body.style.overflow.includes('hidden')) {
      this.alreadyHidden = true
    } else {
      document.body.style.overflow = 'hidden'
    }
  },

  beforeUnmount() {
    // Gestion du scroll
    if (!this.alreadyHidden) {
      document.body.style.overflow = ''
    }
  },

  methods: {
    handleMouseDown() {
      this.insideModal = false
    },

    handleMouseUp() {
      if (!this.insideModal && this.closeOption) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped>
/* Glass modal backdrop */
.glass-modal-backdrop {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  overflow-x: hidden;
  overflow-y: auto;
}

.modal-content-wrapper {
  max-width: 100vw;
  max-height: none;
  overflow-x: hidden;
  display: flex;
  align-items: center;
  min-height: 100%;
}

/* Modal animation */
.glass-modal-backdrop {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    backdrop-filter: blur(0px);
    -webkit-backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
  }
}

/* Responsive adjustments */
@media (max-width: 991.98px) {
  .glass-modal-backdrop {
    padding: 1rem;
  }
}

@media (max-width: 575.98px) {
  .glass-modal-backdrop {
    padding: 0.5rem;
    /* Sur mobile, si le contenu dépasse, on utilise flex-start pour permettre le scroll */
    align-items: flex-start;
  }

  .modal-content-wrapper {
    min-height: auto;
    padding: 1rem 0;
  }
}

@media (max-width: 480px) {
  .glass-modal-backdrop {
    padding: 0.25rem;
  }

  .modal-content-wrapper {
    padding: 0.5rem 0;
  }
}

/* Gestion pour les écrans très hauts - garder centré */
@media (min-height: 800px) {
  .glass-modal-backdrop {
    align-items: center !important;
  }

  .modal-content-wrapper {
    min-height: auto;
  }
}
</style>
